/** Fechas como texto ISO: 'YYYY-MM-DD' (día) y 'YYYY-MM' (mes). Sin zonas horarias. */
export type IsoDate = string;
export type Month = string;

export function monthOf(date: IsoDate): Month {
  return date.slice(0, 7);
}

export function isMonth(s: string): boolean {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(s);
}

export function isIsoDate(s: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(`${s}T00:00:00Z`));
}

export function prevMonth(m: Month): Month {
  let y = Number(m.slice(0, 4)), mo = Number(m.slice(5, 7)) - 1;
  if (mo === 0) { mo = 12; y -= 1; }
  return `${y}-${String(mo).padStart(2, '0')}`;
}

export function monthEnd(m: Month): IsoDate {
  const y = Number(m.slice(0, 4)), mo = Number(m.slice(5, 7));
  const last = new Date(Date.UTC(y, mo, 0)).getUTCDate();
  return `${m}-${String(last).padStart(2, '0')}`;
}

export function monthRange(from: Month, to: Month): Month[] {
  const out: Month[] = [];
  let y = Number(from.slice(0, 4)), m = Number(from.slice(5, 7));
  const ty = Number(to.slice(0, 4)), tm = Number(to.slice(5, 7));
  while (y < ty || (y === ty && m <= tm)) {
    out.push(`${y}-${String(m).padStart(2, '0')}`);
    m++; if (m === 13) { m = 1; y++; }
  }
  return out;
}
